import getBrandUTMFlags from "./getBrandUTMFlags";
import parseUtm from "./parseUtm";

const getParsedRedirectUrl = ({
	brand,
	upsell = false,
	redirectUrl = "",
} = {}) => {
	if (!brand) return "";

	const { masked_url: brandUrl, override_utm: overrideUtm } = brand || {};
	const utmFlags = getBrandUTMFlags({ brand, upsell });

	if (!redirectUrl && !brandUrl) return "";

	const parsedRedirectUrl = parseUtm(
		redirectUrl || brandUrl,
		utmFlags,
		overrideUtm
	);

	return parsedRedirectUrl;
};
export default getParsedRedirectUrl;
